import { basicAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";

export const blackDuckCoverityRest = productVariant({
  identifier: "blackDuckCoverityRest",
  authLabel: "Coverity REST",
  protocol: "http",
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://coverity.example.com/api"),
  auth: basicAuth({
    username: { from: "secret", field: "username" },
    password: { from: "secret", field: "password" },
  }),
  steps: [
    {
      title: "Set up Black Duck Coverity",
      items: [
        {
          kind: "markdown",
          content:
            "Use a Coverity Connect account with read access to the REST API. Enter its API URL, username, and password or authentication key below. See the [view endpoint reference](https://docs.blackduck.com/r/coverity/2026.6/coverity-documentation/get-api/view/v1/views.html).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder: "https://coverity.example.com/api",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Replace the example host with the HTTPS hostname and port of the organization’s Coverity Connect server. Keep the /api prefix; Coverity REST resources are documented under paths such as /api/v2 and /api/view/v1.",
        },
        {
          kind: "input",
          label: "Coverity username",
          required: true,
          target: {
            kind: "secrets",
            field: "username",
          },
          helperText:
            "A Coverity Connect user permitted to read the REST API resources used by the connector.",
        },
        {
          kind: "input",
          label: "Coverity password or authentication key",
          required: true,
          target: {
            kind: "secrets",
            field: "password",
          },
          helperText:
            "The Coverity Connect password. Where supported by the deployment, an authentication key may be used in place of the password.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://coverity.example.com/api")
          .trim()
          .replace(/\/+$/, "") + "/view/v1/views",
      ...{ method: "GET" },
    }),
  },
});
